import styled from 'styled-components'

const MyDiv = styled.div`
.flex_header{
    align-items: center;
    justify-content: space-between;
}
.overview_card {
  border-radius: 10px;
  padding: 12px;
  margin-top: 10px;
}
.green {
  background-color: #D0FAE6;
}
.orange {
  background-color:#FFEED4;
}
.react-calendar {
    font-family: 'Poppins', sans-serif;   
    width: 220px;
    max-width: 100%;
    font-size: 12px;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  }

  .react-calendar__tile {
    padding: 6px 0;
  }

  .react-calendar__navigation button {
    min-width: 28px;
    font-size: 12px;
  }

  .react-calendar__month-view__days__day--weekend {
    color: #ff6b6b;
  }


// calendar css
.fc .fc-scrollgrid {
  border-radius: 3px;
  overflow: hidden; 
  border: 1px solid #eee; 
}
  
.fc .fc-col-header-cell-cushion{
    font-size: 14px;
    font-weight: 500;
    color: #000;
    font-family: "Poppins", sans-serif;
}
.fc .fc-daygrid-day-number{
    font-size: 14px;
    font-weight: 500;
    color: #000;
    font-family: "Poppins", sans-serif;
}
.fc .fc-scrollgrid-liquid{
    border: 0;
}
.fc-theme-standard td, .fc-theme-standard th{
    border: 1px solid #eee;
}
.fc-theme-standard th{
    border-bottom: 0;
}
.fc .fc-daygrid-day.fc-day-today, .fc .fc-timegrid-col.fc-day-today{
    background-color: #EEF3FB
}
.fc .fc-daygrid-day-top{
    justify-content: center;
}

.fc-day-content {
  text-align: center;
  font-family: 'Poppins', sans-serif;
}

.status-label {
  font-size: 10px;
  margin-top: 14px;
  padding: 2px 6px;
  border-radius: 6px;
  display: inline-block;
  white-space: nowrap;
}

 .status_badge {
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}

 .status_badge.green {
  background-color: #00B10333;
  color:#008000; 
}
.status_badge.red {
  background-color: #FF00001A;
  color:#FF0000 ; 
}
.status_badge.orange {
  background-color: #f9e0ceff;
  color:#dd6b20;
}
.status_badge.yellow {
  background-color: #FFCC0033; 
  color:#FFA500;
}
.status_badge.purple {
  background-color: #8000801A; 
  color:#800080;
}
.status_badge.blue {
  background-color: #0000FF1A;
  color:#0000FF 
}
.status_badge.pink {
  background-color: #fce6f2ff; 
  color:#df127cff;
}
.status_badge.gray {
  background-color: #c8ccd0ff;
  color:#404347ff;
}
    .status_badge.cyan {
  background-color: #e0f7faff;
  color: #00bcd4;              
}
`
export default MyDiv
